import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Button, HtmlContent } from './ui';
import { useLocalePrice } from '../utils';

const StyledPlan = styled.article`
  background-color: ${standardColours.white};
  border-radius: 20px;
  padding: 30px;

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 50px;
  `}
`;

const StyledInner = styled.div`
  position: relative;
`;

const StyledHeading = styled.h3`
  color: ${brandColours.secondary};
  width: calc(100% - 70px);
  ${fontSize(24)};

  ${minBreakpointQuery.small`
    width: calc(100% - 90px);
    ${fontSize(27)};
  `}

  ${minBreakpointQuery.xxlarge`
    width: calc(100% - 110px);
    ${fontSize(30)};
  `}
`;

const StyledText = styled.p`
  margin-top: 10px;
  line-height: 1.5;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}

  ${minBreakpointQuery.xxlarge`
    ${fontSize(20)};
  `}
`;

const StyledPrice = styled.span`
  display: block;
  margin-top: 20px;
  font-weight: ${fontWeights.semibold};
  ${fontSize(18)};

  ${minBreakpointQuery.small`
    margin-top: 25px;
    ${fontSize(20)};
  `}

  ${minBreakpointQuery.xxlarge`
    margin-top: 30px;
    ${fontSize(22)};
  `}
`;

const StyledButton = styled(Button)`
  width: 100%;
  margin-top: ${({ hasPrice }) => (hasPrice ? '30px' : '60px')};
`;

const StyledIcon = styled.img`
  max-width: 70px;
  max-height: 70px;
  width: 100%;
  height: 100%;
  padding: 10px;
  border-radius: 50%;
  background-color: ${brandColours.primary};
  position: absolute;
  top: -50px;
  right: 0;

  ${minBreakpointQuery.small`
    max-width: 90px;
    max-height: 90px;
    top: -70px;
    padding: 15px;
  `}

  ${minBreakpointQuery.xxlarge`
    max-width: 110px;
    max-height: 110px;
    padding: 20px;
    top: -90px;
  `}
`;

const StyledContent = styled(HtmlContent)`
  margin-top: 30px;

  ${minBreakpointQuery.small`
    margin-top: 45px;
  `}
`;

const Plan = ({ heading, text, prices, link, icon, content, ...props }) => {
  const localePrice = useLocalePrice(prices);

  return (
    <StyledPlan {...props}>
      <StyledInner>
        <StyledHeading>{heading}</StyledHeading>
        {text && <StyledText>{text}</StyledText>}
        {localePrice && <StyledPrice>{localePrice}</StyledPrice>}
        <StyledButton to={link.pageUrl} hasPrice={localePrice ? true : false}>
          {link.text}
        </StyledButton>
        <StyledIcon src={icon.url} alt={icon.alt} loading="lazy" />
        <StyledContent content={content} />
      </StyledInner>
    </StyledPlan>
  );
};

export default Plan;
